module.exports = __webpack_public_path__ + "static/media/3-4.a5a65009.jpg";